import { SelectorOption } from "../../../components/Redux/BasicSelector";

const CodecTypeOptions: SelectorOption[] = [
  { label: "Default", id: "" },
  { label: "Auto", id: "auto" },
  { label: "HTTP1", id: "http1" },
  { label: "HTTP2", id: "http2" },
  { label: "HTTP3", id: "http3" },
];
export default CodecTypeOptions;
